import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-formgrid p-grid p-m-4" }
const _hoisted_2 = { class: "p-fluid p-col-12 p-md-12 p-mt-2" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-12" }
const _hoisted_7 = { class: "p-field p-col-12 p-md-12 p-mt-2" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-field p-col-12 p-md-12 p-mt-2" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-custom-view-save-dialog",
    class: "p-fluid kn-dialog--toolbar--secondary",
    style: _ctx.olapCustomViewSaveDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.savingCustomizedView')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: !_ctx.view.name,
        onClick: _ctx.saveCustomizedView
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                            'p-invalid': !_ctx.view.name && _ctx.viewNameTouched
                        }],
              modelValue: _ctx.view.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.view.name = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewNameTouched = true))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " *", 1)
          ]),
          (!_ctx.view.name && _ctx.viewNameTouched)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("small", _hoisted_6, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_InputText, {
              id: "description",
              class: "kn-material-input",
              modelValue: _ctx.view.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.view.description = $event)),
              modelModifiers: { trim: true }
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.description')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.view.scope,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.view.scope = $event)),
              options: _ctx.olapCustomViewSaveDialogDescriptor.scopeOptions
            }, null, 8, ["modelValue", "options"]),
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.scope')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}